import { Head, Link } from '@inertiajs/react';

import { DesignFooter, DesignHeader, UtilityBar } from '@/Components/Design';

type Props = {
    resource: {
        slug: string;
        title: string;
        excerpt: string | null;
        body: string;
        category: string | null;
        publishedAt: string | null;
    };
};

export default function ResourceShow({ resource }: Props) {
    return (
        <>
            <Head>
                <title>{resource.title}</title>
            </Head>
            <div style={{ background: 'var(--paper)', minHeight: '100vh' }}>
                <UtilityBar />
                <DesignHeader active="Resources" />

                <article data-res-article style={{ maxWidth: 760, margin: '0 auto', padding: '64px 24px 80px' }}>
                    <nav aria-label="Breadcrumb" style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'var(--ink-mute)', marginBottom: 24 }}>
                        <Link href="/" style={{ color: 'inherit', textDecoration: 'none' }}>Home</Link>
                        <span>/</span>
                        <Link href="/resources" style={{ color: 'inherit', textDecoration: 'none' }}>Resources</Link>
                        <span>/</span>
                        <span style={{ color: 'var(--ink)' }}>{resource.title}</span>
                    </nav>
                    {resource.category && (
                        <div style={{ fontSize: 12, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 10, fontWeight: 600 }}>
                            {resource.category}
                        </div>
                    )}
                    <h1 style={{ fontSize: 48, lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: 16, fontFamily: 'var(--font-serif)', fontWeight: 500 }}>
                        {resource.title}
                    </h1>
                    {resource.publishedAt && (
                        <div style={{ fontSize: 13, color: 'var(--ink-mute)', marginBottom: 32 }}>
                            {new Date(resource.publishedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                        </div>
                    )}
                    {resource.excerpt && (
                        <p style={{ fontSize: 19, color: 'var(--ink-soft)', lineHeight: 1.6, marginBottom: 32, fontFamily: 'var(--font-serif)', fontStyle: 'italic' }}>
                            {resource.excerpt}
                        </p>
                    )}
                    <div
                        style={{ fontSize: 17, color: 'var(--ink)', lineHeight: 1.75 }}
                        // Body is admin-authored Markdown rendered to HTML server-side.
                        dangerouslySetInnerHTML={{ __html: resource.body }}
                    />
                </article>

                <DesignFooter />
            </div>
        </>
    );
}
